export default function (phone) {
  phone = phone.replace(/\D+/g, '')

  const dummyNumbers = ['71111111111', '72222222222', '73333333333', '74444444444', '75555555555', '76666666666', '77777777777', '78888888888', '79999999999', '70000000000', '77000000000', '77011111111', '77010000000', '77011111112', '77017681808', '77789727952', '77017777701', '77771111111', '77071111111', '77077777777']

  for (let i = 0; i <= dummyNumbers.length; i++) {
    if (phone === dummyNumbers[i]) {
      return false
    }
  }
  return true
}
